import React from 'react';

import styled from 'styled-components';

import { getFileNameFromURL } from '../utils';

const Attachment = styled.a`
  display: flex;
  align-items: center;
`;

const AttachmentName = styled.div`
  color: var(--dark-blue);
  margin-left: 5px;
  height: 16px;
  font-size: 12px;
  cursor: pointer;
`;

interface Props {
  fileUrl: string;
}

const ShopNotesAttachment = ({ fileUrl }: Props) => {
  const file_name = getFileNameFromURL(fileUrl);

  if (!file_name) {
    return null;
  }

  return (
    <Attachment href={fileUrl} target="_blank" rel="noopener noreferrer">
      <img alt="attachment" src="/icons/attachment.svg" />
      <AttachmentName>{file_name}</AttachmentName>
    </Attachment>
  );
};

export default ShopNotesAttachment;
